import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [{
  exact: true,
  path: '/home/operated/operationConf',
  owner: '/home',
  authority: 'operationConf',
  component: Loadable({
    loader: () => import('./list'),
    loading: () => <RouteLoading />
  })
},
{
  exact: true,
  path: '/home/operated/operationConf/check/:id',
  owner: '/home',
  authority: 'operationConf',
  component: Loadable({
    loader: () => import('./check'),
    loading: () => <RouteLoading />
  })
}];